module.exports = __webpack_public_path__ + "static/media/customer-success-cnes-feature.8ad302ac.jpg";